import React, { useState } from 'react'
import PropTypes from 'prop-types'

import Select from '../Select/Select'

import CloseIconSVG from 'component/svgComponents/close'
import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import Row from 'component/utils/Row'
import Button from 'component/Button'

const FIELDS = ['isMission', 'isPersonalProfile', 'lsCdMenus']

const REGISTER_TYPES = [
  { value: 1, label: 'option.all' },
  { value: 2, label: 'missionMenu.table.personalProfile' },
  { value: 3, label: 'missionMenu.table.mission' },
]

const SideFilterForm = ({
  appPermissions = [],
  initialValues = { lsCdMenus: [] },
  setSideFilterVisible = () => {},
  submit,
  translate,
  webPermissions = [],
}) => {
  const registerTypesOptions = REGISTER_TYPES.map((r) => ({
    ...r,
    label: translate(r.label),
  }))

  const appPermissionsOptions = appPermissions.map((p) => ({
    value: p.cdMenu,
    label: p.dsMenuParent ? `${p.dsMenuParent}>${p.dsMenu}` : p.dsMenu,
  }))

  const webPermissionsOptions = webPermissions.map((p) => ({
    value: p.cdMenu,
    label: p.dsMenuParent
      ? `${translate(p.dsMenuParentNotTranslated)}>${translate(
          p.dsMenuNotTranslated
        )}`
      : translate(p.dsMenuNotTranslated),
  }))

  const getInitialSelectedRegisterTypeValue = () => {
    if (initialValues.isMission && initialValues.isPersonalProfile) {
      return 1
    }
    if (initialValues.isPersonalProfile) {
      return 2
    }
    return 3
  }

  const getInitialSelectedPermissionsValue = (filter) =>
    initialValues.lsCdMenus.filter((i) => filter.some((a) => a.cdMenu === i))

  const [selectedAppPermissions, setSelectedAppPermissions] = useState(
    getInitialSelectedPermissionsValue(appPermissions)
  )
  const [selectedWebPermissions, setSelectedWebPermissions] = useState(
    getInitialSelectedPermissionsValue(webPermissions)
  )
  const [selectedRegisterType, setSelectedRegisterType] = useState(
    getInitialSelectedRegisterTypeValue()
  )

  const handleSubmit = () => {
    const values = {
      ...initialValues,
      isMission: selectedRegisterType !== 2,
      isPersonalProfile: selectedRegisterType !== 3,
      lsCdMenus: [...selectedAppPermissions, ...selectedWebPermissions],
    }

    submit(values)
  }

  return (
    <>
      <div className='bg-filter' onClick={setSideFilterVisible} />
      <div className='right-filter-container'>
        <CloseIconSVG className="right-filter-svg" onClick={setSideFilterVisible} />
        <h3 className='margin-bottom-triple'>
          <strong>{translate('mobile.filter')}</strong>
        </h3>
        <Select
          label={translate('missionMenu.sideFilter.webPermissions')}
          required
          fill
          closeMenuOnSelect={false}
          isMulti
          onChange={(options) =>
            setSelectedWebPermissions(
              options ? options.map((o) => o.value) : []
            )
          }
          options={webPermissionsOptions}
          placeholder={translate(
            'missionMenu.addModal.webPermissions.placeholder'
          )}
          value={webPermissionsOptions.filter((p) =>
            selectedWebPermissions.some((p2) => p2 === p.value)
          )}
        />
        <Select
          label={translate('missionMenu.sideFilter.appPermissions')}
          required
          fill
          closeMenuOnSelect={false}
          isMulti
          onChange={(options) =>
            setSelectedAppPermissions(
              options ? options.map((o) => o.value) : []
            )
          }
          options={appPermissionsOptions}
          placeholder={translate(
            'missionMenu.addModal.appPermissions.placeholder'
          )}
          value={appPermissionsOptions.filter((p) =>
            selectedAppPermissions.some((p2) => p2 === p.value)
          )}
        />
        <Select
          label={translate('missionMenu.sideFilter.registerType')}
          required
          fill
          onChange={(option) => setSelectedRegisterType(option.value)}
          options={registerTypesOptions}
          placeholder={translate('missionMenu.sideFilter.registerType')}
          value={registerTypesOptions.find(
            (r) => r.value === selectedRegisterType
          )}
        />
        <Row>
          <Col xs={12} className='margin-bottom margin-top no-padding'>
            <Button
              className='btn btn-primary full-w'
              onClick={handleSubmit}
              text={translate('filter_button_label')}
            />
          </Col>
        </Row>
      </div>
    </>
  )
}

SideFilterForm.propTypes = {
  appPermissions: PropTypes.array.isRequired,
  initialValues: PropTypes.object.isRequired,
  setSideFilterVisible: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  webPermissions: PropTypes.array.isRequired,
}

export default Form({ fields: FIELDS })(SideFilterForm)

export { SideFilterForm }
